import { takeLatest, put } from 'redux-saga/effects';
import api from '../../../../utils/apiConfig';

import { showSnackBar } from '../../../../components/UI/HOC/SnackBar/store/actions';
import UrlConfig from './urls';
import OperatorActionTypes from './types';
import axios from 'axios';
import {
  fetchOperatorListingFailure,
  fetchOperatorListingSuccess,
  fetchOperatorVehicleTyreSuccess,
  getUploadedImagesSuccess,
  getUploadedImagesRcBackSuccess,
  rcFrontResKey,
  rcBackResKey,
  fetchOperatorVehicleTyreFailure,
  updateVehicleSuccess,
  operatorDocListSuccess,
  adharFrontResKey,
  adharBackResKey,
  OperatorGetUploadedImagesSuccess,
  OperatorGetUploadedBackImagesSuccess,
  OperatorPostUploadDocSubmitSuccess,
  OperatorPostUploadDocSuccess,
  operatorDocListFailure,
  fetchGPSImageUrlsSuccess,
  fetchGPSImageUrlsFailure,
  fetchGPSImageUrlsStart,
  gpsOrderRequestFailure,
  gpsOrderRequestSuccess,
  fetchGpsVariantSuccess,
  fetchGpsVariantFailure,
  updateVehicleDataSuccess,
  uploadDocumentsSuccess,
  uploadDocumentsFailure,
  uploadDocumentsReset,
  fetchOperatorVehicleListingStart,
  fetchVehicleReqDataSuccess,
  fetchVehicleReqDataFailure,
} from './actions';

function* updateVehicle(action: any) {
  const formData = {
    fileName: action.payload.name,
    docType: 'RC',
  };
  const requestURL = UrlConfig.vehicleUpdate(action.params);
  try {
    const response = yield api.put(requestURL, action.payload);
    yield put(updateVehicleSuccess('true'));

    if (response.status == 200) {
      yield put(updateVehicleSuccess('true'));
      yield put(showSnackBar({ variant: 'success', message: 'successFully Submitted' }));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      yield put(updateVehicleSuccess('false'));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in submitting.' }));
  }
}
function* updateVehicleData(action: any): any {
  const requestURL = UrlConfig.vehicleUpdateV2();

  const { index, payload, callBackDispatchLoader } = action.payload;
  try {
    const response = yield api.patch(requestURL, payload);
    if (response.data.vehicleInputWidget === null) {
      yield put(fetchOperatorVehicleListingStart());
    } else {
      yield put(updateVehicleDataSuccess({ index, vehicleInputWidget: response.data.vehicleInputWidget }));
    }
    callBackDispatchLoader(false);
    yield put(uploadDocumentsReset());
  } catch (e) {
    console.log(e);
    callBackDispatchLoader(false);
    yield put(showSnackBar({ variant: 'error', message: 'Error in submitting.' }));
  }
}

function* fetchOperatorVehicleListingFunction(action: any) {
  // const requestURL = UrlConfig.fetchOperatorVehicleList();
  const requestURL = UrlConfig.fetchOperatorVehicleListV2();
  try {
    const response = yield api.get(requestURL);
    yield put(fetchOperatorListingSuccess(response.data.vehicles));
  } catch (e) {
    yield put(fetchOperatorListingFailure('false'));
  }
}

function* fetchOperatorVehicleTyreSizeTonHeight(action: any) {
  const requestURL = UrlConfig.fetchOperatorVehicleTyreSizeTonHeight(action.payload);
  try {
    const response = yield api.get(requestURL);
    // const res = response.data.data ? response.data.data : response.data.sizeInFeet;
    if (response.status == 200 || response.data.data) {
      yield put(fetchOperatorVehicleTyreSuccess(response.data.data));
    } else {
      yield put(fetchOperatorVehicleTyreSuccess([]));
    }
  } catch (e) {
    yield put(fetchOperatorVehicleTyreFailure([]));
  }
}

async function uploadImageOnAws(data: any, action: any) {
  return await fetch(` ${data}`, {
    headers: { Accept: 'application/json, text/plain, /' },
    method: 'PUT',
    body: action.payload,
  })
    .then((response) => {})
    //Then with the data from the response in JSON...
    .then((data) => {})
    .catch((error) => {
      console.error('Error:', error);
    });
}

function* postUploadDoc(action: any) {
  const formData = {
    fileName: action.payload.name,
    docType: action.typeImg,
  };

  const requestURL = UrlConfig.postUploadDocUrl(action.typeImg);

  try {
    const response = yield api.post(requestURL, formData);
    let Key = response.data.data.imgResourceKey;
    let resKey = {
      payload: Key,
      typeImg: action.typeImg,
    };

    const uploadUrl = response.data.data.imgUrl;
    let requestURL2 = uploadUrl.toString();

    if (response) {
      yield uploadImageOnAws(requestURL2, action);

      if (action.imgSide === 'front') {
        yield getUploadedRc(resKey);
        yield put(rcFrontResKey(Key));
      } else {
        yield getUploadedRcBack(resKey);
        yield put(rcBackResKey(Key));
      }
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in submitting.' }));
  }
}

function* getUploadedRc(resKey: any) {
  const requestURL = UrlConfig.getUploadedDocImg(resKey.payload, resKey.typeImg);
  try {
    const response = yield api.get(requestURL);
    if (resKey.typeImg === 'RC') {
      yield put(getUploadedImagesSuccess(response.data.data.viewUrl));
    }
    // else if(resKey.typeImg ==='ID_PROOF'){
    //   yield put(OperatorGetUploadedImagesSuccess(response.data.data.viewUrl))

    // }
  } catch (e) {
    // yield put(getUploadedImagesFailure())
  }
}

function* getUploadedRcBack(resKey: any) {
  const requestURL = UrlConfig.getUploadedDocImg(resKey.payload, resKey.typeImg);
  try {
    const response = yield api.get(requestURL);
    if (resKey.typeImg === 'RC') {
      yield put(getUploadedImagesRcBackSuccess(response.data.data.viewUrl));
    } else if (resKey.typeImg === 'ID_PROOF') {
      yield put(OperatorGetUploadedBackImagesSuccess(response.data.data.viewUrl));
    }
  } catch (e) {
    // yield put(showSnackBar({ variant: 'error', message: 'Something went wrong.' }));
  }
}

function* getOperatorDocList(resKey: any) {
  const headers = {
    token: '707bff39-edb0-4281-859b-72a943dcb8ae',
    'Content-Type': 'application/json',
  };

  const requestURL = UrlConfig.getOperatorDocListx(resKey.payload);
  try {
    const response = yield api.get(requestURL);

    if (response.status == 200) {
      yield put(operatorDocListSuccess(response.data.data));
    } else {
      yield put(operatorDocListSuccess([]));
    }
  } catch (e) {
    yield put(operatorDocListFailure([]));
    yield put(showSnackBar({ variant: 'error', message: 'APi failed.' }));
  }
}

function* OperatorPostUploadDoc(action: any) {
  const formData = {
    fileName: action.payload.name,
    docType: action.typeImg,
  };

  const requestURL = UrlConfig.postUploadDocUrl(action.typeImg);

  try {
    const response = yield api.post(requestURL, formData);
    yield put(OperatorPostUploadDocSuccess('', ''));
    let Key = response.data.data.imgResourceKey;
    let resKey = {
      payload: Key,
      typeImg: action.typeImg,
    };

    const uploadUrl = response.data.data.imgUrl;
    let requestURL2 = uploadUrl.toString();

    if (response) {
      yield uploadImageOnAws(requestURL2, action);
      if (action.imgSide === 'front') {
        yield operatorGetUploadedImage(resKey, action.imgSide);
        yield put(adharFrontResKey(Key));
      } else {
        yield operatorGetUploadedImage(resKey, action.imgSide);
        yield put(adharBackResKey(Key));
      }
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in submitting.' }));
  }
}

function* updateOperator(action: any) {
  const formData = {
    fileName: action.payload.name,
    docType: 'RC',
  };
  const requestURL = UrlConfig.operatorUpdateDoc(action.params);
  try {
    const response = yield api.put(requestURL, action.payload);

    if (response.status == 200) {
      yield put(showSnackBar({ variant: 'success', message: 'successFully Submitted' }));

      yield put(OperatorPostUploadDocSubmitSuccess(true));
    } else {
    }
  } catch (e) {
    yield put(OperatorPostUploadDocSubmitSuccess(false));
    yield put(showSnackBar({ variant: 'error', message: 'Error in submitting.' }));
  }
}

function* operatorGetUploadedImage(resKey: any, imgSide: any) {
  const requestURL = UrlConfig.getUploadedDocImg(resKey.payload, resKey.typeImg);
  try {
    const response = yield api.get(requestURL);

    if (imgSide === 'front') {
      yield put(OperatorGetUploadedImagesSuccess(response.data.data.viewUrl));
    } else {
      yield put(OperatorGetUploadedBackImagesSuccess(response.data.data.viewUrl));
    }
  } catch (e) {}
}

function* gpsOrderRequest(action: any) {
  const requestURL = UrlConfig.gpsorderRequest();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (response.data.success) {
      yield put(gpsOrderRequestSuccess(response.data.success));
      yield put(
        showSnackBar({
          variant: 'success',
          message:
            'GPS order has been placed successfully.\nWe will contact you within 24Hrs to get vehicle details and availablility',
        }),
      );
    } else {
      yield put(
        showSnackBar({
          variant: 'error',
          message: response.data.message,
        }),
      );
      yield put(gpsOrderRequestFailure());
      yield put(fetchGPSImageUrlsStart());
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Some error occured while placing your order' }));
    yield put(gpsOrderRequestFailure());
    yield put(fetchGPSImageUrlsStart());
  }
}

function* fetchGPSImgUrls(action: any) {
  const requestURL = UrlConfig.fetchGPSImageUrls();
  try {
    const response = yield api.get(requestURL);
    if (response.data.success) {
      yield put(fetchGPSImageUrlsSuccess(response.data.data));
    } else {
      yield put(fetchGPSImageUrlsFailure());
      yield put(showSnackBar({ variant: 'error', message: 'Error occured in fetching images' }));
    }
  } catch (e) {
    yield put(fetchGPSImageUrlsFailure());
    yield put(showSnackBar({ variant: 'error', message: 'Error occured in fetching images' }));
  }
}

function* fetchGPSVariant(action: any) {
  const requestURL = UrlConfig.fetchGpsVariant();
  try {
    const response = yield api.get(requestURL, action.payload);
    // if (response.data.success) {
    //   yield put(fetchGPSImageUrlsSuccess(response.data.data));
    //   yield put(showSnackBar({ variant: 'success', message: response.data.message }));
    // } else {
    //   yield put(fetchGPSImageUrlsFailure());
    //   yield put(showSnackBar({ variant: 'error', message: 'Error occured in fetching images' }));
    // }
    if (response.data.success) {
      console.log(response.data);
      yield put(fetchGpsVariantSuccess(response.data.data));
    } else {
      yield put(fetchGpsVariantFailure());
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error occured in fetching images' }));
  }
}

function* uploadDocument(action: any): any {
  const requestURL = UrlConfig.uploadDocument();
  const { id, formData, callBackDispatchLoader } = action.payload;
  try {
    const response = yield api.post(requestURL, formData);
    yield put(uploadDocumentsSuccess({ id, data: response.data }));
    callBackDispatchLoader(false);
  } catch (error) {
    callBackDispatchLoader(false);
    yield put(uploadDocumentsFailure());
  }
}
function* fetchVehicleRequiredData(action: any): any {
  const { id } = action.payload;
  const requestURL = UrlConfig.fetchRequiredVehicleData(id);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchVehicleReqDataSuccess({ data: response.data, vId: id }));
  } catch (error) {
    yield put(fetchVehicleReqDataFailure());
  }
}
function* onboardingOperatorSaga() {
  yield takeLatest(OperatorActionTypes.FETCH_OPERATOR_VEHICLE_LISTING_START, fetchOperatorVehicleListingFunction);
  yield takeLatest(
    OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TYRE_LISTING_START,
    fetchOperatorVehicleTyreSizeTonHeight,
  );
  yield takeLatest(OperatorActionTypes.POST_UPLOAD_DOC_START, postUploadDoc);
  yield takeLatest(OperatorActionTypes.GET_UPLOADED_IMAGES_START, getUploadedRc);
  yield takeLatest(OperatorActionTypes.GET_UPLOADED_RC_BACK_IMAGES_START, getUploadedRcBack);
  yield takeLatest(OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_START, updateVehicle);
  yield takeLatest(OperatorActionTypes.OPERATOR_DOC_LIST_START, getOperatorDocList);
  yield takeLatest(OperatorActionTypes.OPERATOR_POST_UPLOAD_DOC_START, OperatorPostUploadDoc);
  yield takeLatest(OperatorActionTypes.OPERATOR_GET_UPLOADED_IMAGES_START, getUploadedRc);
  yield takeLatest(OperatorActionTypes.OPERATOR_GET_UPLOADED_BACK_IMAGES_START, getUploadedRcBack);
  yield takeLatest(OperatorActionTypes.FETCH_GPS_IMAGE_URLS, fetchGPSImgUrls);
  yield takeLatest(OperatorActionTypes.POST_OPERATOR_DATA_UPDATE_START, updateOperator);
  yield takeLatest(OperatorActionTypes.GPS_ORDER_REQUEST, gpsOrderRequest);
  yield takeLatest(OperatorActionTypes.FETCH_GPS_VARIANT, fetchGPSVariant);
  yield takeLatest(OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_START_V2, updateVehicleData);
  yield takeLatest(OperatorActionTypes.UPLOAD_DOCUMENT, uploadDocument);
  yield takeLatest(OperatorActionTypes.FETCH_VEH_REQ_DATA, fetchVehicleRequiredData);
}

export default onboardingOperatorSaga;
